"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ImagePreview = _interopRequireDefault(require("./ImagePreview"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  button: {
    position: "relative",
    width: theme.spacing(8),
    height: theme.spacing(12),
    marginRight: theme.spacing(1),
    color: "inherit"
  },
  image: {
    position: "relative",
    border: "1px solid",
    borderRadius: "2px",
    borderColor: "#666",
    width: theme.spacing(8),
    height: theme.spacing(8),
    "&[aria-selected=true]": {
      borderWidth: "2px",
      borderColor: "white"
    }
  },
  label: {
    position: "absolute",
    top: theme.spacing(8),
    width: "100%",
    textAlign: "center",
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold",
    fontSize: "12px",
    marginTop: theme.spacing(0.5)
  }
}));

const ButtonFilter = (_ref) => {
  let imageUrl = _ref.imageUrl,
      _ref$imageFilters = _ref.imageFilters,
      imageFilters = _ref$imageFilters === void 0 ? {} : _ref$imageFilters,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Filter" : _ref$label,
      selected = _ref.selected,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["imageUrl", "imageFilters", "label", "selected", "onClick"]);

  const classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.button
  }, _react.default.createElement(_ButtonBase.default, {
    className: classes.image,
    onClick: onClick,
    "aria-selected": selected
  }, _react.default.createElement(_ImagePreview.default, _extends({
    imageUrl: imageUrl,
    imageFilters: imageFilters
  }, props))), _react.default.createElement(_Typography.default, {
    noWrap: true,
    className: classes.label
  }, label));
};

var _default = ButtonFilter;
exports.default = _default;
module.exports = exports.default;